import script from "./ListEvents.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListEvents.vue?vue&type=script&lang=ts&setup=true"

import "./ListEvents.vue?vue&type=style&index=0&id=1002776a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1002776a"]])

export default __exports__